import { getId } from '@src/containers/UtmGenerator/helpers'

export const ErrorListData = [
  {
    id: getId(),
    text: 'utm_generator.tool.error.list_1'
  },
  {
    id: getId(),
    text: 'utm_generator.tool.error.list_2'
  },
  {
    id: getId(),
    text: 'utm_generator.tool.error.list_3'
  },
  {
    id: getId(),
    text: 'utm_generator.tool.error.list_4'
  },
  {
    id: getId(),
    text: 'utm_generator.tool.error.list_5'
  },
  {
    id: getId(),
    text: 'utm_generator.tool.error.list_6'
  }
]
